import { Component, OnInit, HostListener } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { UserSubscriptionDilogComponent } from '../user-subscription-dilog/user-subscription-dilog.component';
import { DatePipe } from '@angular/common';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-ze-users',
  templateUrl: './admin-ze-users.component.html',
  styleUrls: ['./admin-ze-users.component.scss']
})
export class AdminZeUsersComponent implements OnInit {
  private ResponseVerifiedNormalUserList: Subject<any> = new Subject();
  private searchZeUsersSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  pipe = new DatePipe('en-US');
  role: any;
  epcId: any;
  roleName: string;
  adminZEUserList: any;
  limit: any = 10;
  offset: any = 0;
  ZEUser: {};
  search: any = '';
  count: any;
  page = 1;
  selectedNormalUserId: any;
  closeResult: string;
  userChangePasswordRequestObject: any = {};
  zeUserDeviceList: any = [];
  deviceObject: { user_id: any; };
  SadminAccess: any = [];
  access: any;
  constructor(private dashbord: DashboardService, private dialog: MatDialog, private router: Router, private modalService1: NgbModal,
    private toastr: ToastrService) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');
    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'User Registration') {
          this.access = x.access;
        }
      });
    }
    this.getAllAdminZEUserList(this.search, this.limit, this.offset);
     this.searchAllWmsUsers();
  }

  editZEUser(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
      }
    };
    this.router.navigate(['/inject-solar/add-admin-ze-users/'], navigationExtras);
  }
  // EDIT DEVICE
  EditDevice(userId, epc_id, is_emeter, is_wms) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
        'epc_id': epc_id,
        'is_emeter': is_emeter,
        'is_wms': is_wms
      }

    };
    this.router.navigate(['/inject-solar/register-zeusers-device-byadmin'], navigationExtras);
  }
  // get all admin normal user list
  getAllAdminZEUserList(search, limit, offset) {
    if (offset == 0) {
      this.page = 1;
    }
    this.ZEUser = {
      search: search,
      limit: limit,
      offset: offset
    };
    this.dashbord.getAllAdminZEUserList(this.ZEUser)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserList))
      .subscribe(
        async data => {
          this.count = 0;
          this.adminZEUserList = [];
          if (data.status) {
            this.count = data.count;
            this.adminZEUserList = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  searchAllWmsUsers() {
    this.searchZeUsersSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        this.search = searchValue;
        this.getAllAdminZEUserList(this.search, 10, 0);
      })
    ).subscribe();
  }

  onSearchWmsUsers(event: KeyboardEvent) {
    this.searchZeUsersSubject.next((event.target as HTMLInputElement).value.trim() || "");
  }

  // change password modal start
  openResetPasswordDialog(content, id) {
    this.selectedNormalUserId = id;
    this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  viewDevice(viewDevices, userId) {
    this.zeUserDeviceList = [];
    this.getDeviceForZeUser(userId);
    this.modalService1.open(viewDevices, { size: <any>'xl' });
  }
  // change date
  ChangeDate(Chnagedate) {
    this.modalService1.open(Chnagedate, { size: <any>'md' });
  }
  // change password by userid Normal User
  changePasswordByUserId(formData) {
    this.userChangePasswordRequestObject = {
      user_id: this.selectedNormalUserId,
      new_password: formData.value.newPassword,
      confirm_password: formData.value.confirmPassword
    };
    this.dashbord.changePasswordNormalAndWmsByUserId(this.userChangePasswordRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success('Password Changed Successfully!!');
            this.modalService1.dismissAll();
            this.getAllAdminZEUserList(this.search, this.limit, this.offset);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  //get devices by user id
  getDeviceForZeUser(userId) {

    this.deviceObject = {
      user_id: userId,
    };
    this.dashbord.getAdminZeUserDevicesById(this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserList))
      .subscribe(
        async data => {
          this.zeUserDeviceList = [];
          if (data.status) {
            this.zeUserDeviceList = data.device_info;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // pagination for normal user list
  nextPageNew(pageIndex): void {
    this.offset = (pageIndex - 1) * 10;
    this.getAllAdminZEUserList(this.search, this.limit, this.offset);
  }
  public confirmDialog(id: any): void {
    let message = 'Are you sure you want to delete this User?';
    let title = 'Confirm Action';
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteZeUser(id);
      }
    });
  }
  deleteZeUser(id) {
    var deleteNormalUserObj = {
      user_id: id,
    };
    this.dashbord.deleteZEUserByAdmin(deleteNormalUserObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getAllAdminZEUserList(this.search, this.limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // renew user subscription dilog box
  public confirmRenewDialog(id: any): void {
    const dialogRef = this.dialog.open(UserSubscriptionDilogComponent, {
      width: '400px',
      data: id
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (result.start_date != undefined && result.start_date != '' && result.start_date != null && result.end_date != '' && result.end_date != undefined && result.end_date != null) {
          this.renewSubscriptionZeUser(id, result);
        }
      }
    });
  }

  // renew user by id
  renewSubscriptionZeUser(id, result) {
    var subscriptionNormalUserObj = {
      user_id: id,
      start_dt: this.pipe.transform(result.start_date, 'yyyy-MM-dd'),
      end_year: result.end_date
    };
    this.dashbord.adminZeUserSubscription(subscriptionNormalUserObj)
      .pipe(takeUntil(this.ResponseVerifiedNormalUserList))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getAllAdminZEUserList(this.search, this.limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {
    this.ResponseVerifiedNormalUserList.next();
    this.ResponseVerifiedNormalUserList.complete();
    this.destroy$.next();
    this.destroy$.complete();
    this.searchZeUsersSubject.next();
    this.searchZeUsersSubject.complete();
  }
}
